
export class SearchResponseModel<T> {
    data?: Array<T>;
    totalCount?: number;

    constructor(init?: Partial<SearchResponseModel<T>>) {
        if (init) {
            Object.assign(this, init);
        }
    }
}

export type ResponseModel<T = any> = {
    isError: boolean;
    status: number;
    data?: T;
    message: string;
}
